import * as Sentry from '@sentry/browser';

export const captureException = e => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(e);
  } else if (process.env.NODE_ENV === 'development') {
    // Locally, log everything to the console instead of Sentry
    console.warn('Sentry -> captureException:', e); // eslint-disable-line no-console
  }
};

export const initialize = () => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: 'https://6b2027205c9f41b09958c40d73c795d8@sentry.io/1329171',
    });
  }
};
